export default __webpack_public_path__ + "static/media/banner-11.8c222162.jpg";